var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { KeyIcon } from '@heroicons/react/24/solid';
import Button from '@web/components/layout/Button';
import SearchBar from '@web/components/layout/SearchBar';
import { useFilters } from '@web/utility/hooks/useFilters';
import { useNavigateTo } from '@web/utility/hooks/useNavigateTo';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
var DocAlertsConfigFilter = function (_a) {
    var createDocumentAlertConfig = _a.createDocumentAlertConfig;
    var t = useTranslation().t;
    var location = useLocation();
    var navigateTo = useNavigateTo();
    var docSearch = useFilters().docSearch;
    function onQueryChange(query) {
        navigateTo({
            pathname: location.pathname,
            newFilters: { docSearch: query }
        });
    }
    return (_jsx("div", { children: _jsxs("div", __assign({ className: "flex flex-col sm:flex-row gap-3 sm:gap-0" }, { children: [_jsx("div", __assign({ className: "sm:w-4/12 text-lg font-medium" }, { children: _jsx("h1", { children: t('docAlerts.docAlertsConfig.title') }) })), _jsxs("div", __assign({ className: "flex flex-col sm:flex-row w-full sm:w-8/12 justify-between sm:justify-end gap-4" }, { children: [_jsx(SearchBar, { placeholder: t('docAlerts.docAlertsConfig.quickFilterByName'), query: docSearch || '', setQuery: onQueryChange, className: 'sm:w-5/12' }), _jsxs(Button, __assign({ type: "button", variant: "primary", className: "self-center mb-2 sm:mb-0", onClick: createDocumentAlertConfig }, { children: [_jsx(KeyIcon, { className: "w-4 h-4 inline-block mr-2 mt-1" }), _jsx("span", __assign({ className: "text-sm text-center font-medium" }, { children: t('docAlerts.docAlertsConfig.addDocAlert') }))] }))] }))] })) }));
};
export default DocAlertsConfigFilter;
